import { ChatBubbleService } from './chat-bubble.service';
import { EmulatorMessage } from '../../../../../shared/models/emulator';
import {
  Component,
  EmbeddedViewRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ImageComponent } from './image-chat-bubble/image-chat-bubble.component';
import { FileComponent } from './file-chat-bubble/file-chat-bubble.component';
import { VoiceNoteComponent } from './voice-note/voice-note.component';
import { VideoComponent } from './video-chat-bubble/video-chat-bubble.component';
import { LocationComponent } from './location-chat-bubble/location-chat-bubble.component';
import { ReceiveContactComponent } from './receive-contact/receive-contact.component';
import { InteractiveMessageChatBubbleComponent } from './interactive-message-chat-bubble/interactive-message-chat-bubble.component';
import { ButtonsChatBubbleComponent } from './buttons-chat-bubble/buttons-chat-bubble.component';
import { OptionsChatBubbleComponent } from './options-chat-bubble/options-chat-bubble.component';
import { RequestLocationComponent } from './request-location/request-location.component';
import { ActionUrlChatBubbleComponent } from './action-url-chat-bubble/action-url-chat-bubble.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ReadReceiptComponent } from './read-receipt/read-receipt.component';
import { UrlPreviewComponent } from '../url-preview/url-preview.component';
import { IsUserMessagePipe } from '../pipes/is-user-message.pipe';
import { GetListContentPipe } from '../pipes/get-list-content.pipe';
import {SMS, USSD} from '../../../../../shared/utils/config';

@Component({
    selector: 'app-chat-bubble',
    templateUrl: './chat-bubble.component.html',
    styleUrls: ['./chat-bubble.component.scss'],
    imports: [ImageComponent, FileComponent, VoiceNoteComponent, VideoComponent, LocationComponent, ReceiveContactComponent, InteractiveMessageChatBubbleComponent, ButtonsChatBubbleComponent, OptionsChatBubbleComponent, RequestLocationComponent, ActionUrlChatBubbleComponent, NgClass, NgTemplateOutlet, ReadReceiptComponent, UrlPreviewComponent, IsUserMessagePipe, GetListContentPipe]
})

export class ChatBubbleComponent implements OnInit {
    @Input() emulatorMessage: EmulatorMessage;
    @Output() sendMessage: EventEmitter<any> = new EventEmitter();
    @Output() sendLocation: EventEmitter<any> = new EventEmitter();
    @ViewChild('urlPreviewContainer', {static: true}) urlPreviewContainer!: TemplateRef<any>;

    urlPreviewData: { mainUrl: string, rootUrl: string, remainder: string } = null;
    public shouldShowCharCount = false;
    public charCount: number;
    public currentChannel: number;

    constructor(public chatBubbleService: ChatBubbleService, private viewContainerRef: ViewContainerRef) {
    }

    ngOnInit() {
        this.currentChannel = this.emulatorMessage.channelId;
        this.checkURL();
        this.shouldShowCharCount = this.showCharacterCount();
        if (this.shouldShowCharCount) {
            this.charCount = this.getStringLength(this.getFullString());
        }
    }

    private getFullString(): string {
        let str = '';
        if (this.urlPreviewData['mainUrl'] !== null) {
            str += this.urlPreviewData['mainUrl'];
        }
        if (this.urlPreviewData['rootUrl'] !== null) {
            str += this.urlPreviewData['rootUrl'];
        }
        if (this.urlPreviewData['remainder']) {
            str += this.urlPreviewData['remainder'];
        }
        return str;
    }

    checkURL() {

        if (this.emulatorMessage.mediaMetaData['bubbleType'] === 'contact') {
            this.urlPreviewData = null;
            return;
        }

        if (this.emulatorMessage.channelPayload) {
            this.urlPreviewData = this.chatBubbleService.urlPreview(this.emulatorMessage.mediaMetaData['content']);
            return this.urlPreviewData;
        }

        this.urlPreviewData = this.chatBubbleService.urlPreview(this.emulatorMessage.message);
        return this.urlPreviewData;
    }

    checkdefaultURL(): String {
        if (this.emulatorMessage.channelPayload) {
            if (this.emulatorMessage.channelPayload['event']) {
                return this.chatBubbleService.urlCheck(this.emulatorMessage.channelPayload['event']['moText'][0]['content']);
            }
            if (this.emulatorMessage.channelPayload['messages']) {
                return this.chatBubbleService.urlCheck(this.emulatorMessage.channelPayload['messages'][0]['content']);
            }
        }

        return this.chatBubbleService.urlCheck(this.emulatorMessage.message);
    }

    getStringLength(str) {
        if (!str) {
            return;
        }
        return str.replace(/(<([^>]+)>)/gi, '').trim().length;
    }

    get content(): any {
        return this.emulatorMessage.mediaMetaData;
    }

    get bubbleType() {
        return this.emulatorMessage.mediaMetaData['bubbleType'];
    }

    get direction() {
        return this.chatBubbleService.isUserMessage(this.emulatorMessage);
    }

    showCharacterCount(): boolean {
        return (
            !this.direction &&
            (this.emulatorMessage.channelId === USSD || this.emulatorMessage.channelId === SMS)
        );
    }

    sendMessageEmitter(event) {
        this.sendMessage.emit(event);
    }

    sendLocationEmitter(event) {
        this.sendLocation.emit(event);
    }
}
